class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);    
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(false, '', false);
    this.updatePickupAvailability();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();      
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();     
    }    
    var current_varid = this.currentVariant.id;
    $('.pro_mob_size li').each(function(e){
      var all_varid = $(this).find('a').data('id');      
      if(current_varid==all_varid){
		$(this).addClass('active').siblings('li').removeClass('active');
      }
    });    
    var totalvariants = this.currentVariant.options.length;
    $('.product__info-wrapper').each(function(e){
      var selected_val = $(this).find('input[type="radio"]:checked').length;
      if(selected_val==totalvariants){
      	$('.prebtncart').hide();
        $('.cartbtn_cls').show();
      }else{
      	$('.prebtncart').show();
        $('.cartbtn_cls').hide();
      }      
    });   
  }
  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
    let text = "";
    var var_option = this.options;
    var_option.forEach(varloop);
    document.getElementsByClassName("variant_cartname")[0].innerHTML = text;
    if(document.getElementsByClassName("variant_stickysize")[0]) document.getElementsByClassName("variant_stickysize")[0].innerHTML = text;
      //  document.querySelectorAll("variant_cartname").forEach((variantname) => {
    //   variantname.innerHTML = text;
    // });
    function varloop(item, index) {
      text += "<span>"+ item +"</span>"; 
    }
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );
    if (!newMedia) return;
    const parent = newMedia.parentElement;
    parent.prepend(newMedia);
    window.setTimeout(() => { parent.scroll(0, 0) });
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        document.getElementById(`price-${this.dataset.section}`)?.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
	var cartbtnlebl = document.querySelector(".cartbtnlabel");
	var tiggernotofy = document.getElementById("BIS_trigger");
	var clartbrncls = document.querySelector(".cartbtn_cls");
	if (!addButton) return;	
    if (disable) {
      addButton.setAttribute('disabled', true);
      if (text) cartbtnlebl.textContent = text;	
	  tiggernotofy.classList.remove("hidenotify");
	  clartbrncls.classList.add("hidecartbtn");
    } else {
      addButton.removeAttribute('disabled');
      cartbtnlebl.textContent = window.variantStrings.addToCart;
	  tiggernotofy.classList.add("hidenotify");
	  tiggernotofy.setAttribute('data-variant-id', this.currentVariant.id);
	  clartbrncls.classList.remove("hidecartbtn");
    }	
    if (!modifyClass) return;
  }

  setUnavailable() {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
	var cartbtnlebl = document.querySelector(".cartbtnlabel");
    if (!addButton) return;
    cartbtnlebl.textContent = window.variantStrings.unavailable;	
    document.getElementById(`price-${this.dataset.section}`)?.classList.add('visibility-hidden');
	clartbrncls.classList.remove("hidecartbtn");
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);
